import {createAsyncThunk} from '@reduxjs/toolkit';

import {showMessageFromResponse} from 'shared/utils';

import {REGIONS_SLICE} from '../model/constants';
import {fetchRegions} from './api';

export const loadRegions = createAsyncThunk(
    `${REGIONS_SLICE}/loadRegions`,
    async (_, {rejectWithValue}) => {
        try {
            const {data: regionsData} = await fetchRegions();

            return regionsData;
        } catch (e) {
            showMessageFromResponse({response: e.response, isError: true});
            return rejectWithValue([]);
        }
    },
);
